import DefaultImage from 'assets/images/img.png';

// approximate date when thumb structure changed for part of image
// required to show proper image grid locally
// todo - delete when staging env is up
// const URL_STRUCTuRE_CHANGE_TIMESTAMP = 1652329973000; // ~12/05/2022

const getThumbnailImageSource = (image, isThumbImage = true) => {
  if (!image?.url) {
    return DefaultImage;
  }

  const prefix = image?.url.startsWith('/') ? '' : '/';

  if (!isThumbImage || image.isNew) {
    return `${process.env.REACT_APP_MEDIA_CDN_API}${prefix}${image?.url}`;
  }

  const fileNameParts = (image?.url || '').split('/');
  const fileData = fileNameParts.pop();

  if(image?.created_at) {
    const [name, extension] = fileData.split('.');
    let thumbFileName;

    if(extension) {
      thumbFileName = [...fileNameParts, `${name}-thumb.${extension}`].join('/');
    } else {
      thumbFileName = [...fileNameParts, name].join('/');
    }

    return `${process.env.REACT_APP_MEDIA_CDN_API}${prefix}${thumbFileName}`;
  }

  return DefaultImage;
};

export default getThumbnailImageSource;
